import React, { Component } from 'react'
import { Row, Col, Badge, Button, Table, Form, InputGroup } from 'react-bootstrap';
import './StyleOrder.css';
import { convertRiceTypeENToTH, addCommaInNumber } from '../../helpers/function'
import { AdminNav, Loading } from '../../helpers';
import { onPrint } from '../../helpers/functionForLicense';
export default class Order extends Component {
  state = {
    CheckWeightSheet: {
      description: {
        description: {},
      }, 
    },
    FinancialSheet: {
      description: {
        description: {},
      },
    },
    weightLeft: 0,
    weightOriginal: 0,
    paidWageSheet: {
    },
    active: [],
    data: {}
  }

  componentWillMount() {
    if (this.props.CheckWeightSheet.description[this.props.desIndex]['isComplete'] != true) {
      this.props.CheckWeightSheet.description[this.props.desIndex]['bagQuantity'] = 0
    }
    if (this.props.pastData) {
      let totalWeight = 0
      let pp = this.props.pp
      if (!Array.isArray(pp)) {
        pp = [pp]
      }
      let subID = this.props.subID
      Object.values(this.props.pastData).map((data) => {
        totalWeight += ((data['netWeight'] * data['bagQuantity']))
      })
      let KGM = pp[subID]?.['NetWeightKGM']
      if(!Number.isFinite(KGM)){
        if(KGM){
          KGM = parseFloat(KGM.replace(',',''))
        }
      }
      let weightLeft = KGM - totalWeight
      if (isNaN(weightLeft)) {
        weightLeft = 0
      }
       

      this.setState({
        ...this.state,
        FinancialSheet: this.props.FinancialSheet,
        paidWageSheet: this.props.paidWageSheet,
        weightLeft: weightLeft,
        weightOriginal: KGM,
      })
    } else {
      // console.log('new data')
      this.setState({
        ...this.state,
        FinancialSheet: this.props.FinancialSheet,
        paidWageSheet: this.props.paidWageSheet,
      })
    }
  }
  handleChangeValue = (e, idx) => {
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        [idx]: {
          ...this.state.data[idx],
          [e.target.id]: e.target.value
        }
      }
    }, () => {
      // console.log(this.state)
    })
  }
  handleButtonClick = (e, idx) => {
    let { handleButtonClick } = this.props
    switch (e.target.id) {
      case 'true':
        this.setState({
          active: {
            ...this.state.active,
            [idx]: true,
          },
        }, handleButtonClick('validationStatus', true, idx))
        break;
      case 'false':
        this.setState({
          active: {
            ...this.state.active,
            [idx]: false,
          },
        }, handleButtonClick('validationStatus', false, idx))
        break;
      case 'else':
        this.setState({
          active: {
            ...this.state.active,
            [idx]: 'else',
          },
        }, handleButtonClick('validationStatus', 'else', idx))
        break;
    }
  }
  renderLicenseID(licenseID) {
    return <a href="javascript:void(0)" onClick={() => { onPrint(licenseID) }}> {licenseID.slice(6, licenseID.length)}</a>
  }
  renderShippingDate(shippingDate) {
    let isoDate = new Date(shippingDate)
    if (isoDate) {
      return <p>{isoDate.getDate()} / {isoDate.getMonth() + 1} / {isoDate.getFullYear() + 543}</p>
    } else {
      return <p></p>
    }
  }
  renderWeightLeft(weightLeft, currentTon) {



    if (this.props.CheckWeightSheet.description[this.props.desIndex]['isComplete'] == true) {
      if (parseInt(weightLeft) - weightLeft == 0) {
        if(parseFloat((parseFloat(((parseFloat(weightLeft) / 1000))).toPrecision(12))).toFixed(4) < 0.0001 && parseFloat((parseFloat(((parseFloat(weightLeft) / 1000))).toPrecision(12))).toFixed(4) > 0){
          return addCommaInNumber(0)
        }else{
          return addCommaInNumber(parseFloat((parseFloat(((parseFloat(weightLeft) / 1000))).toPrecision(12))).toFixed(4))
        }
      } else {
        if(parseFloat((parseFloat(((weightLeft * 1000) / 1000000)).toPrecision(12))) < 0.0001 && parseFloat((parseFloat(((weightLeft * 1000) / 1000000)).toPrecision(12))) > 0){
          return addCommaInNumber(0)
        }else{
          return addCommaInNumber(parseFloat((parseFloat(((weightLeft * 1000) / 1000000)).toPrecision(12))))
        }
      }
    } else {
      if (parseInt(weightLeft) - weightLeft == 0) {
        if(parseFloat((parseFloat(parseFloat(weightLeft - currentTon) / 1000)).toPrecision(12)).toFixed(4) < 0.0001 && parseFloat((parseFloat(parseFloat(weightLeft - currentTon) / 1000)).toPrecision(12)).toFixed(4) > 0){
          return addCommaInNumber(0)
        }else{
          return addCommaInNumber(parseFloat((parseFloat(parseFloat(weightLeft - currentTon) / 1000)).toPrecision(12)).toFixed(4))
        }
      } else {
        if(parseFloat((parseFloat((((weightLeft * 1000) - (currentTon * 1000)) / 1000000)).toPrecision(12))) < 0.0001 && parseFloat((parseFloat((((weightLeft * 1000) - (currentTon * 1000)) / 1000000)).toPrecision(12))) > 0 ){
          return addCommaInNumber(0)
        }else{
          return addCommaInNumber(parseFloat((parseFloat((((weightLeft * 1000) - (currentTon * 1000)) / 1000000)).toPrecision(12))))
        }
      }
    }
  }
  renderOfficerName(officerName) {
    try {
      let cutIndex = officerName.indexOf('นาย')
      let officerNumber = officerName.slice(0, cutIndex)
      let name = officerName.slice(parseInt(cutIndex) + 3, officerName.length)
      return `${officerNumber} ${name}`
    } catch (error) {
      return officerName
    }
  }
  renderWeight(weightInput) {
    if (parseInt(weightInput) - weightInput != 0) {
      return addCommaInNumber(parseFloat((parseFloat(((weightInput * 1000) / 1000000)).toPrecision(12))))
    } else {
      return addCommaInNumber(parseFloat((parseFloat(((weightInput * 1000) / 1000000)).toPrecision(12))).toFixed(4))
    }
  }
  render() {
    let { FinancialSheet, active, paidWageSheet } = this.state;
    let { handleExtra, handleSubmit, handleTime, CheckWeightSheet } = this.props;
    if (FinancialSheet) {
      return (
        <div>
          {FinancialSheet.description.description.map((data, idx) => (
            <div style={{ marginTop: '4rem' }}>
              <Row>
                <Col align="center">
                  <h1>Job order NO : {FinancialSheet.description.requestID}<br /><br /></h1>
                  <h3><Badge variant="primary">License No :<br />{data.licenseID}</Badge></h3><br />
                </Col>

                <Col><b>Shipper: </b> {this.props.getCompanyName(FinancialSheet.description.companyID) || FinancialSheet?.description?.companyID} <br />
                  <b>Supplier :</b> {this.props.getCompanyName(FinancialSheet.description.companyID) || FinancialSheet?.description?.companyID}<br />
                  <b>Ex rice mill / godown: </b>{FinancialSheet.description.surveyLocateName}<br />
                  <b>Quality said tone : </b>{data.riceTypeID} <br />
                  <b>Vessel : </b>{data.vehicleName} <b>Destination : </b>{data.destinationCity} <br />
                  <b>Gross weight :</b> {parseFloat(data.grossWeight).toFixed(6)} Kgs<br />
                  <b>Tare weight      : </b>       {(data.grossWeight - data.netWeight).toFixed(6)} Kgs<br />
                  <b>Nett weight     : </b>{data.netWeight} Kgs<br />
                  <b>Container NO     : </b> <br />
                  <b>Loading in lighter     :</b> <br />
                </Col>
              </Row>
            </div>
          ))}
          <Col>
            <Table className="table table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">ปริมาณ</th>
                  <th scope="col">จำนวนเงิน</th>
                </tr>
              </thead>
              <tbody>
                {FinancialSheet.description.description.map((data) => {
                  return (<tr>
                    <td>{data.quantity} ตัน</td>
                    <td>{data.quantity * 2.5} บาท</td>
                  </tr>)
                })}
                <tr>
                  <td>ค่ารถ</td>
                  <td><input type="number" onChange={handleExtra}></input></td>
                </tr>
                <tr>
                  <td>เวลาเริ่ม</td>
                  <td><input id='start' onChange={(e) => { handleTime(e) }} placeholder='08.00'></input></td>
                </tr>
                <tr>
                  <td>เวลาสิ้นสุด</td>
                  <td><input id='end' onChange={(e) => { handleTime(e) }} placeholder='18.00'></input></td>
                </tr>
                <tr>
                  <td>รวม</td>
                  <td>{this.props.paidWageSheet.total}</td>
                </tr>
              </tbody>
            </Table>
            <Row align="center">
              <Col align="center">
                <Button variant="secondary" size="lg" >ยกเลิก</Button>
              </Col>
              <Col align="center">
                <Button variant="success" size="lg" onClick={handleSubmit}>ยืนยันปิดงาน</Button><br /><br />
              </Col>
            </Row>
            <Row align="center">
              <Col align="center">
                <Button size="lg" variant="warning">Print</Button>
              </Col>
            </Row>
          </Col>
        </div>
      )
    }
    else if (this.props.itemIndex != -99 && CheckWeightSheet.description[this.props.desIndex]) {
      return (
        <div>
          <div style={{ width: '100%', alignContent: 'center', textAlign: 'center', fontSize: '22px' }}  >
            <p><b><u>RICE INSPECTION REPORT</u></b></p>
          </div>
          {
            <div>
              <div className='TopSpace'>
                <Row>
                  <Col align="center">
                    <Form className='ScaleDown'>
                      <Form.Group className="FormGroup" as={Row} controlId="Shipper">
                        <Form.Label className='text-left' column sm="4">
                          Shipper : {}
                        </Form.Label>
                        <Col className='text-left' sm="5">
                          {this.props.companyNameEN || CheckWeightSheet['companyID']}
                          {/* {console.log(CheckWeightSheet['companyEN'])} */}
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="Supplier">
                        <Form.Label className='text-left' column sm="4">
                          Supplier :
                        </Form.Label>
                        <Col className='text-left' sm="5">

                        <Form.Control id={`companyNameEN`} 
                            onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex)}}
                             defaultValue={CheckWeightSheet.description[this.props.desIndex]['companyNameEN'] || this.props.companyNameEN} />

                          {/* {this.props.companyNameEN || CheckWeightSheet['companyID']} */}
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="godown">
                        <Form.Label className='text-left' column sm="4">
                          Ex rice mill / godown :
                        </Form.Label>
                        <Col className='text-left' className='text-left' sm="4">
                          {CheckWeightSheet.godown}
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="Quality">
                        <Form.Label className='text-left' column sm="4">
                          Quality said tobe :
                        </Form.Label>
                        <Col className='text-left' sm="5">
                          {CheckWeightSheet.description[this.props.desIndex].riceTypeName || convertRiceTypeENToTH(CheckWeightSheet.description[this.props.desIndex].riceTypeID, this.props.riceTypeIDAndName, 'standalone')}
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="Vessel">
                        <Form.Label className='text-left' column sm="4">
                          Vessel :
                        </Form.Label>
                        <Col className='text-left' sm="5">
                          <InputGroup>
                          {console.log(CheckWeightSheet)}
                            <Form.Control id={`vehicleName${this.props.desIndex}`} 
                            onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex)}}
                             value={CheckWeightSheet.description[this.props.desIndex].vehicleName || CheckWeightSheet.description[this.props.desIndex][`vehicleName${this.props.desIndex}`]} />
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="Destination">
                        <Form.Label className='text-left' column sm="4">
                          Destination :
                        </Form.Label>
                        <Col className='text-left' sm="5">
                          {CheckWeightSheet.description[this.props.desIndex].destinationCity}
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="bagQuantity">
                        <Form.Label className='text-left' column sm="4">
                          No. of bags :
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup className='input-sm'>
                            {(() => {
                              if (CheckWeightSheet.description[this.props.desIndex]['isComplete'] == true) {
                                return <Form.Control className='input-sm' id="bagQuantity" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} value={addCommaInNumber(CheckWeightSheet.description[this.props.desIndex]['bagQuantity'])} />
                              }
                              else if (this.props.validateData?.bagQuantity != undefined) {
                                return <Form.Control className='input-sm' id="bagQuantity" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} value={addCommaInNumber(this.props.validateData['bagQuantity'])} />
                              }
                              else {
                                return <Form.Control className='input-sm' id="bagQuantity" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} defaultValue={0} />
                              }
                            })()}
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="GrossWeight">
                        <Form.Label className='text-left' column sm="4">
                          Gross weight : <br />
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup>
                            <Form.Control id={`grossWeight${this.props.desIndex}`} onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} value={(() => {
                              // Object.keys(CheckWeightSheet.description[this.props.desIndex]).indexOf
                              return addCommaInNumber(CheckWeightSheet.description[this.props.desIndex]?.[`grossWeight${this.props.desIndex}`])
                            })()} />
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="TarWeight">
                        <Form.Label className='text-left' column sm="4">
                          Nett weight :
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup>
                            <Form.Control id="netWeight" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} value={addCommaInNumber(CheckWeightSheet.description[this.props.desIndex].netWeight)} />
                          </InputGroup>
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="TotalGrossWeight">
                        <Form.Label className='text-left' column sm="4">
                          Total gross weight : <br />
                        </Form.Label>
                        <Col sm="8">
                          <InputGroup>
                            <Col className='text-right' sm="5">
                              {(() => {
                                if (CheckWeightSheet.description[this.props.desIndex]) {
                                  // console.log(CheckWeightSheet.description[this.props.desIndex])
                                  if (CheckWeightSheet.description[this.props.desIndex]['bagQuantity']) {
                                    return addCommaInNumber((parseFloat(CheckWeightSheet.description[this.props.desIndex][`grossWeight${this.props.desIndex}`]) * parseInt(CheckWeightSheet.description[this.props.desIndex]['bagQuantity'])).toFixed(4))
                                  }
                                } else {
                                  return <div></div>
                                }
                              })()}
                            </Col>
                            <InputGroup.Append>
                              <InputGroup.Text>Kgs.</InputGroup.Text>
                            </InputGroup.Append>
                          </InputGroup>

                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="TarWeight">
                        <Form.Label className='text-left' column sm="4">
                          Total tare weight :
                        </Form.Label>
                        <Col sm="8">
                          <InputGroup>
                            <Col className='text-right' sm="5">
                              {(() => {
                                // console.log(this.props.CheckWeightSheet.description[this.props.desIndex][this.props.desIndex]['QuantityBags'])
                                if (CheckWeightSheet.description[this.props.desIndex]) {
                                  if (CheckWeightSheet.description[this.props.desIndex]['bagQuantity']) {
                                    return addCommaInNumber(((parseFloat(CheckWeightSheet.description[this.props.desIndex][`grossWeight${this.props.desIndex}`]) * parseInt(CheckWeightSheet.description[this.props.desIndex]['bagQuantity'])) - (parseFloat(CheckWeightSheet.description[this.props.desIndex].netWeight) * parseInt(CheckWeightSheet.description[this.props.desIndex]['bagQuantity']))).toFixed(4))
                                  }

                                } else {
                                  return <div></div>
                                }
                              })()}
                            </Col>
                            <InputGroup.Append>
                              <InputGroup.Text>Kgs.</InputGroup.Text>
                            </InputGroup.Append>
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="TotalTarWeight">
                        <Form.Label className='text-left' column sm="4">
                          Total net weight :
                        </Form.Label>
                        <Col sm="8">
                          <InputGroup>
                            <Col className='text-right' column sm="5">
                              {(() => {
                                // console.log(this.props.CheckWeightSheet.description[this.props.desIndex][this.props.desIndex]['QuantityBags'])
                                if (CheckWeightSheet.description[this.props.desIndex]['bagQuantity']) {
                                  if (CheckWeightSheet.description[this.props.desIndex]['bagQuantity']) {
                                    return addCommaInNumber(((parseFloat(CheckWeightSheet.description[this.props.desIndex].netWeight) * parseInt(CheckWeightSheet.description[this.props.desIndex]['bagQuantity']))).toFixed(4))
                                  }
                                } else {
                                  return <div></div>
                                }
                              })()}
                              {/* {(parseFloat(CheckWeightSheet.description[this.props.desIndex].grossWeight) * parseInt(this.props.CheckWeightSheet.description[this.props.desIndex][this.props.desIndex]['QuantityBags']))-(parseFloat(CheckWeightSheet.description[this.props.desIndex].netWeight) * parseInt(this.props.CheckWeightSheet.description[this.props.desIndex][this.props.desIndex]['QuantityBags']))} */}
                            </Col>
                            <InputGroup.Append>
                              <InputGroup.Text>Kgs.</InputGroup.Text>
                            </InputGroup.Append>
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="images">
                        <Form.Label column sm="4">
                          {(() => {
                            if (this.props.imagesArr) {
                              return (this.props.imagesArr.map((d, idx) => {
                                return (<a style={{ fontSize: '20px' }} target="_blank" rel="noopener noreferrer" href={d['url']}> รูปที่ {idx + 1}    </a>)
                              }))
                            }
                          })()}
                          {(() => {
                            return (<p> น้ำหนักสุทธิ/ตัน {<br />} {this.renderWeight(this.state.weightOriginal)} ตัน</p>)
                          })()}
                        </Form.Label>
                        <Col sm="5">
                          {(() => {
                            let currentTon = ((parseFloat(CheckWeightSheet.description[this.props.desIndex].netWeight) * parseInt(CheckWeightSheet.description[this.props.desIndex]['bagQuantity']))).toFixed(4)
                            return (<p> คงเหลือ/ตัน {<br />} <b style={{ color: '#FF0090' }}> {this.renderWeightLeft(this.state.weightLeft, currentTon)}  </b> <p>ตัน</p></p>)
                          })()}
                        </Col>

                      </Form.Group>

                    </Form>

                    {/* <h1>Job order NO : {CheckWeightSheet.requestID}<br /><br /></h1><h3>
                      <Badge variant="primary">License No :<br />{CheckWeightSheet.description[this.props.desIndex].licenseID} / {parseInt(CheckWeightSheet.description[this.props.desIndex].subID) + 1}</Badge></h3><br /> */}
                  </Col>

                  <Col>
                    <Form>

                      <Form.Group as={Row} controlId="PackingDetail">
                        <Form.Label column sm="4">
                          คำสั่งจ่ายงาน : {CheckWeightSheet['jobID']}
                        </Form.Label>
                        <Form.Label column sm="4">
                          ใบอนุญาติเลขที่ : {this.renderLicenseID(CheckWeightSheet.description[this.props.desIndex]['licenseID'])} {`(${parseInt(CheckWeightSheet.description[this.props.desIndex]['subID']) + 1})`}
                        </Form.Label>
                      </Form.Group>
                      <Form.Group as={Row} controlId="PackingDetail">
                        <Form.Label column sm="4">
                          วันที่บรรทุก :
                        </Form.Label>
                        <Form.Label column sm="4">
                          {this.renderShippingDate(CheckWeightSheet['shippingDate'])}
                        </Form.Label>
                      </Form.Group>
                      <Form.Group as={Row} controlId="officerName">
                        <Form.Label column sm="4">
                          ชื่อพนักงาน (1) :
                        </Form.Label>
                        <Form.Label column sm="4">
                          {console.log(CheckWeightSheet)}
                          {this.renderOfficerName(CheckWeightSheet['officerName'])} / {this.renderOfficerName(CheckWeightSheet['officerName2'])}
                        </Form.Label>
                      </Form.Group>
                      <Form.Group as={Row} controlId="PackingDetail">
                        <Form.Label column sm="4">
                          เวลา :
                        </Form.Label>
                        <Form.Label column sm="4">
                          <InputGroup>
                            <Form.Control id="Time" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} value={CheckWeightSheet.description[this.props.desIndex]['Time']} />
                          </InputGroup>
                        </Form.Label>
                      </Form.Group>
                      <Form.Group as={Row} controlId="lighter">
                        <Form.Label column sm="4">
                          Loading :
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup>
                            <Form.Control as="select" required id="LoaingType"
                              value={CheckWeightSheet.description[this.props.desIndex]['LoaingType'] ? CheckWeightSheet.description[this.props.desIndex]['LoaingType'] : ""}
                              onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }}
                            >
                              <option value="">โปรดเลือก</option>
                              <option value="Container NO">Container</option>
                              <option value="Loading in lighter">Loading in lighter</option>
                              <option value="Alongside">Alongside</option>
                              <option value="Others">Others</option>
                            </Form.Control>
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="lighter">
                        <Form.Label column sm="4">
                          Packing  :
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup>
                            <Form.Control as="select" required id="PackingType"
                              value={CheckWeightSheet.description[this.props.desIndex]['PackingType']}
                              onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }}
                            >
                              <option value="">โปรดเลือก</option>
                              <option value="PP Bag">PP Bag</option>
                              <option value="PE Bag">PE Bag</option>
                              <option value="Inner PE Outer PP">Inner PE / Outer PP Bag</option>
                              <option value="Inner PE Outer CARTON">Inner PE / Outer CARTON</option>
                              <option value="Inner PE Outer TRAY">Inner PE / Outer TRAY</option>
                              <option value="Inner PP Outer PP Bag">Inner PP / Outer PP Bag</option>
                              <option value="Inner PP Outer GUNNY">Inner PP / Outer GUNNY</option>
                              <option value="Inner PE Outer PE Bag">Inner PE / Outer PE Bag</option>

                              <option value="In Bulk">In Bulk</option>
                              <option value="Others">Others</option>
                            </Form.Control>
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="PackingDetail">
                        <Form.Label column sm="4">
                          Packing detail Kgs:
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup>
                            <Form.Control id="PackingDetailKgs" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} defaultValue={CheckWeightSheet.description[this.props.desIndex].Container} />
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="PackingDetail">
                        <Form.Label column sm="4">
                          Packing detail Bags:
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup>
                            <Form.Control id="PackingDetailBags" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} defaultValue={CheckWeightSheet.description[this.props.desIndex].Container} />
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="Container">
                        <Form.Label column sm="4">
                          Remark 1 :
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup>
                            <Form.Control style={{color:'#187BCD'}} id="LoadingDetail1" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} defaultValue={CheckWeightSheet.description[this.props.desIndex]?.LoadingDetail1} />
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="Container">
                        <Form.Label column sm="4">
                          Remark 2 :
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup>
                            <Form.Control style={{color:'#187BCD'}}  id="LoadingDetail2" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} defaultValue={CheckWeightSheet.description[this.props.desIndex]?.LoadingDetail2} />
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="Container">
                        <Form.Label column sm="4">
                          Remark 3 :
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup>
                            <Form.Control style={{color:'#187BCD'}}  id="LoadingDetail3" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} defaultValue={CheckWeightSheet.description[this.props.desIndex]?.LoadingDetail3} />
                          </InputGroup>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="Container">
                        <Form.Label column sm="4">
                          Remark 4 :
                        </Form.Label>
                        <Col sm="5">
                          <InputGroup>
                            <Form.Control style={{color:'#187BCD'}}  id="LoadingDetail4" onChange={(e) => { this.props.handleButtonClick(e.target.id, e.target.value, this.props.desIndex) }} defaultValue={CheckWeightSheet.description[this.props.desIndex]?.LoadingDetail4} />
                          </InputGroup>
                        </Col>
                      </Form.Group>




                      <Col sm="8" >
                        <Button variant={(() => {
                          if (CheckWeightSheet.description[this.props.desIndex]['isComplete'] != true) {
                            return 'success'
                          } else {
                            return 'secondary'
                          }
                        })()} onClick={this.props.handleSubmit}>
                          {(() => {
                            if (CheckWeightSheet.description[this.props.desIndex]['isComplete'] != true) {
                              return 'ยืนยันการตรวจสอบ'
                            } else {
                              return 'แก้ไขการตรวจสอบ'
                            }
                          })()}
                        </Button>
                          &nbsp;&nbsp;&nbsp;
                          <Button variant={(() => {
                          if (CheckWeightSheet.description[this.props.desIndex]['isComplete'] != true) {
                            return 'info'
                          } else {
                            return 'secondary'
                          }
                        })()} onClick={this.props.handleSubmitAndNext}>
                          ยืนยันและถัดไป
                        </Button>
                        {/* <br/><br/>
                        <Button onClick={()=>{}}>
                            จองเลขที่ใบรับรอง
                        </Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button onClick={()=>{}}>
                            ยกเลิกงาน
                        </Button> */}

                      </Col>

                    </Form>
                  </Col>
                </Row>
              </div>
            </div>
          }
        </div>
      )
    }
    // console.log(CheckWeightSheet)
    else {
      return <div></div>
    }
  }
}
